import { NgModule } from '@angular/core';
import { CartNotEmptyGuard, CheckoutAuthGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { CheckoutCartIsValidatedGuard } from '../guards/checkout-cart-validated-guard';
import { CheckoutPaymentModeSelectorComponent } from './checkout-payment-mode-selector.component';

@NgModule({
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutPaymentModeSelector: {
          component: CheckoutPaymentModeSelectorComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutCartIsValidatedGuard, MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
})
export class CheckoutPaymentModeSelectorModule {}
